export { default as IntroduceIcon1 } from './IntroduceIcon1';
export { default as IntroduceIcon2 } from './IntroduceIcon2';
export { default as IntroduceIcon3 } from './IntroduceIcon3';

export { default as CheckIcon } from './CheckIcon';
export { default as CheckedIcon } from './CheckedIcon';
export { default as BackIcon } from './BackIcon';

export { default as DeleteIcon } from './DeleteIcon';
export { default as UploadIcon } from './UploadIcon';
